var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __extends =
  (this && this.__extends) ||
  (function () {
    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (d, b) {
            d.__proto__ = b
          }) ||
        function (d, b) {
          for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]
        }
      return extendStatics(d, b)
    }
    return function (d, b) {
      extendStatics(d, b)
      function __() {
        this.constructor = d
      }
      d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __())
    }
  })()
import React from 'react'
import styled from 'styled-components'
import { ODModal, ODModalBody, ODModalFooter, ODModalHeader, ODModalSize } from '..'
import { ODIcon, ODIcons } from '../../../icons'
import { ODInput } from '../../form'
import { ODButton, ODButtonTheme } from '../../misc'
var Message = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      [
        '\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #2f353a;\n',
      ],
      [
        '\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #2f353a;\n',
      ]
    ))
)
var ConfirmInput = /** @class */ (function (_super) {
  __extends(ConfirmInput, _super)
  function ConfirmInput(props) {
    var _this = _super.call(this, props) || this
    _this.state = {
      value: props.initial || '',
    }
    return _this
  }
  ConfirmInput.prototype.onClickYes = function () {
    this.props.onConfirm(this.state.value)
  }
  ConfirmInput.prototype.onClickNo = function () {
    this.props.onConfirm(undefined)
  }
  ConfirmInput.prototype.render = function () {
    var _this = this
    var value = this.state.value
    var _a = this.props,
      _b = _a.title,
      title = _b === void 0 ? 'Enter input' : _b,
      _c = _a.message,
      message = _c === void 0 ? 'Please enter input value' : _c,
      _d = _a.yes,
      yes = _d === void 0 ? 'Confirm' : _d,
      _e = _a.no,
      no = _e === void 0 ? 'Cancel' : _e,
      placeholder = _a.placeholder,
      mask = _a.mask,
      _f = _a.size,
      size = _f === void 0 ? ODModalSize.Normal : _f,
      isOpen = _a.isOpen
    return React.createElement(
      ODModal,
      {
        isOpen: isOpen,
        toggle: function () {
          return _this.onClickNo()
        },
        size: size,
      },
      React.createElement(
        'div',
        { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement(
          ODModalHeader,
          {
            title: title,
            onClose: function () {
              return _this.onClickNo()
            },
            headerBottomPadding: 30,
          },
          React.createElement(ODIcon, { icon: ODIcons.MaterialError, style: { fontSize: 60 } })
        ),
        React.createElement(
          ODModalBody,
          null,
          React.createElement(Message, null, message),
          React.createElement('div', { style: { height: 35 } }),
          React.createElement(ODInput, {
            placeholder: placeholder || message,
            // @ts-ignore
            onChange: function (e) {
              return _this.setState({ value: e.target.value })
            },
            value: value,
          })
        ),
        React.createElement(
          ODModalFooter,
          null,
          React.createElement(
            ODButton,
            {
              style: { width: '35%' },
              theme: ODButtonTheme.Cancel,
              onClick: function () {
                return _this.onClickNo()
              },
            },
            no
          ),
          React.createElement(
            ODButton,
            {
              style: { width: '65%' },
              theme: ODButtonTheme.Primary,
              onClick: function () {
                return _this.onClickYes()
              },
            },
            yes
          )
        )
      )
    )
  }
  return ConfirmInput
})(React.Component)
export { ConfirmInput }
var templateObject_1
//# sourceMappingURL=ConfirmInput.js.map
